import { BookingDTO } from '@forto-dev/booking-v2-api'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { useBookingApi } from '../api'

type BookingDetailsRouteParams = {
  id: string
}

export const getBookingDetailsQueryCacheKey = (...keys: string[]) => ['bookingsDetail', ...keys]

export const useBookingQuery = (id?: string): UseQueryResult<BookingDTO> => {
  const { getBookingById } = useBookingApi()

  return useQuery({
    queryKey: getBookingDetailsQueryCacheKey(id || ''),
    queryFn: () => getBookingById(id!),
    enabled: !!id,
  })
}

export const useBookingDetailsQuery = (): UseQueryResult<BookingDTO> => {
  const { id } = useParams<BookingDetailsRouteParams>()
  return useBookingQuery(id)
}
